import { createModelStore } from '@/shared/stores/create-model-store'
import { model18InitialModel } from './initial-state'
import { model18DimensionHandlers } from './dimensions'

export const useModel18Store = createModelStore({
  initialModel: model18InitialModel,
  dimensionHandlers: model18DimensionHandlers,
})
